import React from "react";
import AllEmployees from "./EmployeesModule/AllEmployees";

const Employees = () => {
  return (
    <div>
      <AllEmployees />
    </div>
  );
};

export default Employees;
